<div class="backspinner" *ngIf="mode === 'indeterminate'">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
<div *ngIf="!userRecommendedData" style="height: 400px;">
</div>
<div class="dash-profile text-center text-md-left">
    <div class="container">
        <div class="user-profwrapinfo" style="min-height: 600px;">
            <div class="wrap d-md-flex align-items-center">
                <div class="profile-img">
                    <img  [src]="userImage" alt="profile-img">
                </div>
                <div class="profile-info">
                    <h1 *ngIf="userInfo?.name">Hi, {{userInfo?.name}}</h1>
                    <sup *ngIf="userRecommendedData?.message" [innerHTML]="userRecommendedData?.message | safeHtml"></sup>
                    <div class="contact-info d-md-flex">
                    </div>
                    <p class="btn servey-txt cursorHand" *ngIf="!userRecommendedData?.isSurveyTaken" (click)="routeToSurvey()">
                        Personalize your profile by taking this short survey
                    </p>
                    <p class="btn servey-txt cursorHand" *ngIf="userRecommendedData?.isSurveyTaken" (click)="routeToSurveyOnEdit()">
                        Edit Survey
                    </p>
                </div>
            </div>
            <div class="dash-overview text-center text-md-left">
                <h2 class="desh-title">Overview</h2>
                <div class="d-md-flex justify-content-between">
                    <div class="desh-crd d-flex align-items-center justify-content-between" *ngFor="let i of desired_array;let in=index;" [style.background-color]="backgroundColorInOverviewSection(i?.name)">
                        <div class="icns">
                            <span class="material-icons" *ngIf="i?.name == 'totalClassCompleted'">insights</span>
                            <span class="material-icons" *ngIf="i?.name == 'rewardPoints'">check_circle_outline</span>
                            <span class="material-icons" *ngIf="i?.name == 'totalWatchTime'">star_border</span>
                            <span class="material-icons" *ngIf="i?.name == 'totalRatings'">remove_red_eye</span>
                        </div>
                        <div class="detail text-center">
                            <strong class="total" *ngIf="i?.name == 'totalClassCompleted'"> {{i?.value}} </strong>
                            <sup *ngIf="i?.name == 'totalClassCompleted'"> Classes Finished</sup>
                            <strong class="total" *ngIf="i?.name == 'totalWatchTime'"> {{i?.value.toFixed(2)}} </strong>
                            <sup *ngIf="i?.name == 'totalWatchTime'"> Minutes Watched </sup>
                            <strong class="total" *ngIf="i?.name == 'totalRatings'"> {{i?.value}} </strong>
                            <sup *ngIf="i?.name == 'totalRatings'"> Programs Followed </sup>
                            <strong class="total" *ngIf="i?.name == 'rewardPoints'"> {{i?.value}} </strong>
                            <sup *ngIf="i?.name == 'rewardPoints'"> Points Earned</sup>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="recommended-sec">
    <div class="container">
        <div class="d-md-flex justify-content-between">
            <div class="recommended-program">
                <h2 class="text-center text-md-left">Recommended Programs</h2>
                <div>
                    <ngx-slick-carousel class="carousel"  [config]="slideConfig" >
                        <div *ngFor="let i of userRecommendedData?.programs?.data" ngxSlickItem>
                            <app-card-for-class-program [classOrProgramInfo]="i"></app-card-for-class-program>
                        </div>
                    </ngx-slick-carousel>
                </div>
            </div>
            <div class="upcomming-schedle">
            <h2 class="text-center text-md-left">Upcoming's Schedule</h2>
            <app-card-schedule *ngFor="let i of scheduleData?.upcomingData| slice:0:2" [scheduleInfo]="i"></app-card-schedule>
            <strong *ngIf="scheduleData?.upcomingData == 0">No upcoming schedule !</strong>
            </div>
        </div>
    </div>
</div>
<div class="recommended-classes">
    <div class="container">
        <div class="user-profwrapinfo">
            <h2 class="desh-title text-center">Recommended Trips</h2>
            <div class="cat-box-wrap d-flex flex-wrap justify-content-center">
                <ngx-slick-carousel class="carousel"  [config]="slideConfig3" >
                    <div *ngFor="let i of recommendedTrips" class="packages-details cursorHand" (click)="moveToSelectedRecommendedTrip(i)" ngxSlickItem> 
                        <span class="pack-duration">{{ i?.overallDuration ? i?.overallDuration : 0 }} DAY</span>
                        <a style="cursor: pointer;">
                            <h3> {{ i?.name }}</h3>
                            <p class="small-desc">
                                {{ i?.startCity }} {{ i?.startCity ? ', ': ''}}
                                {{ i?.state }} {{ i?.state ? ', ' : ''}}
                                {{ i?.country?.name }}
                            </p>
                        </a>
                        <div class="pack-img ng-star-inserted">
                            <img [src]="imageUrl + i?.defaultImage?.path + i?.defaultImage?.name" alt="img">
                        </div>
                        <div class="view-all-tour text-left">
                            <a class="view-link" > More Details <i class="icon-arrow"></i></a>
                        </div>
                    </div>
                </ngx-slick-carousel>
                <div class="text-center" *ngIf="recommendedTrips?.length == 0">
                    Please fill survey for recommendation !!
                </div>
            </div>
        </div>
    </div>
</div>
<div class="recommended-classes">
    <div class="container">
        <div class="user-profwrapinfo">
            <h2 class="desh-title text-center">Recommended Classes</h2>
            <ngx-slick-carousel class="carousel"  [config]="slideConfig2" >
                <div *ngFor="let i of userRecommendedData?.classes?.data" ngxSlickItem>
                    <app-card-for-class-program [classOrProgramInfo]="i" class="widthHundread"></app-card-for-class-program>
                </div>
            </ngx-slick-carousel>
        </div>
    </div>
</div>
<div class="recommended-instructors">
    <div class="container">
        <div class="d-md-flex justify-content-between">
            <div class="rec-ins">
                <h2 class="text-center text-md-left">Recommended Instructors</h2>
                <div class="row">
                    <ngx-slick-carousel class="carousel"  [config]="slideConfig2" >
                        <div *ngFor="let i of userRecommendedData?.instructors?.data" ngxSlickItem>
                            <app-card-for-instructor class="crd-for-ins" [instructorInfo]="i"></app-card-for-instructor>
                        </div>
                    </ngx-slick-carousel>
                </div>
            </div>
            <div class="rec-playlist">
                <h2 class="text-center text-md-left">Save Playlist</h2>
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 cursorHand" *ngFor="let i of savePlaylist" (click)="goToPlaylistPage(i)">
                        <div class="playlist-cards">
                            <div class="card-item">
                                <img [src]="i?.thumbnail ? i?.thumbnail : '../../assets/images/playlist-img01.jpg' " alt="image">
                                <div class="playlist-txt">
                                  <h4 class="play-title">{{ i?.name }}</h4>
                                  <p class="desc">{{i?.classes ? i?.classes?.length : 0}} Classes</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12 col-md-12 text-center" *ngIf="savePlaylist?.length == 0">
                        <strong>{{resOfPlaylistMessage}}</strong>
                        <button *ngIf="false" (click)="moveToBuyPlanRoute()">Buy a plan </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>